import React from 'react'
import project from '../../project'
import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
import axios from 'axios';

import "../assets/styles/home.scss"

import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const environment = (location.hostname === "localhost") ? 'DEV' : 'PROD'; // PROD or DEV
const apiUrl = (environment === 'PROD') ? 'https://us-central1-ncau-editorial-dapi-prod.cloudfunctions.net/app/api/v1' : 'https://us-central1-ncau-editorial-dapi-dev.cloudfunctions.net/app/api/v1'
// Vote data
const apiURL_storage = (environment === 'PROD') ? 'https://storage.googleapis.com/dapi-prod-data/Socceroos2024AsianCupQF.json' : 'https://storage.googleapis.com/dapi-dev-data/Socceroos2024AsianCupQF.json'
// Players Data
const apiURL_storage_data = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/Socceroos2024AsianCupQF/prod/Socceroos2024AsianCupQF.json'
const apiCollection = 'Socceroos2024AsianCupQF'

// ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'Socceroos',
      firstInteraction: false,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      isMobApp: false,
      votingDisabled: false,
      voteData: null,
      voteDataStorage: null,
      sliderMin: 0,
      sliderMax: 10,
      data: undefined,
      slider1: 5,
      slider2: 5,
      slider3: 5,
      slider4: 5,
      slider5: 5,
      slider6: 5,
      slider7: 5,
      slider8: 5,
      slider9: 5,
      slider10: 5,
      slider11: 5,
      slider12: 5,
      slider13: 5,
      slider14: 5,
      slider15: 5,
      slider16: 5,
      slider17: 5,
      slider18: 5,
      marks: {
        0: <span className="nnd-mark-0">0</span>,
        10: <span className="nnd-mark-10">10</span>
      }
    }

    this.siteCode = this.siteCode.bind(this)
    this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    // this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.checkBreach()
    // this.loadData()
  }

  loadData () {
    
    axios.get(apiURL_storage_data)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      // const currentWeek = titlesRemoved.filter( card => card[0] === this.state.week )
      // console.log('currentWeek', currentWeek)
      // this.processItems(titlesRemoved)
      // console.log('titlesRemoved', titlesRemoved)
      this.setState({
        data: titlesRemoved
      }, function () {
        if ( this.state.breach === true ) {
          this.dataSlash()
        }
        this.loadResults()
      });


    })
    .catch((err) => {
      console.log('err', err)
    })

    // this.loadResults()


  }
    
  loadResults () {
    
    // hit storage for PROD
    if (environment === 'PROD') {
    
      // console.log('Get Votes Storage')
      axios.get(apiURL_storage)
      .then((response) => {
        this.processItems(response.data.items)
        // console.log('response.data', response.data.items);
      })
      // .catch(err => console.error(err))
      .catch((err) => {
        console.log('err', err)
        console.error(err)
      })
    
    } else {
      // hit api direct fot testing/dev NOT FOR PROD
    
      axios.get(`${apiUrl}/vote/fetch`, {
        params: {
          projectName: apiCollection,
          collectionId: 'vote',
          count: 483, // Optional. Set a limit on the number of items returned. Default is 20. (21 x 23 calc players)
          offset: 0, // Optional. Start offset in the collection. Offsets start at 0. 
        }
      })
      .then((res) => {
        const { count, endOffset, items, startOffset, total } = res.data
        // console.log('Fetched votes')
        // console.log('count', count)
        // console.log('endOffset', endOffset)
        // console.log('startOffset', startOffset)
        // console.log('items', items)
        // console.log('total', total)
        // setVoteData(items)

        this.processItems(items)

        this.setState({
          voteData: items
        })
      })
      .catch(err => console.error(err))
    
    }
    
  }

  processItems (items) {
    // console.log('items', items)
    
    let thisState = this
    // console.log('thisState', thisState)

    let playersVotes = {}
    let totalPlayersVotes = 0

    items.forEach(function(element) {
      const playerId = element.categoryA.split('_')[0] //.replace('player', '')
      const scoreId = element.categoryA.split('_')[1]
      // console.log('player', playerId, scoreId, element.total)

      playersVotes[playerId] = playersVotes[playerId] || {};
      playersVotes[playerId][scoreId] = element.total
    })

    // console.log('playersVotes', playersVotes)

    Object.keys(playersVotes).forEach(function (key){
        // console.log(playersVotes[key]);

        let votes = playersVotes[key]
        let playerTotalVotes = 0
        let playerVoteScore = 0

        Object.keys(votes).forEach(function (key){
          playerTotalVotes = playerTotalVotes + votes[key]
          playerVoteScore = playerVoteScore + ( key * votes[key] )
        })

        totalPlayersVotes = totalPlayersVotes + playerTotalVotes

        const fansVoteAve = (playerTotalVotes === 0) ? 0 : playerVoteScore / playerTotalVotes
        let roundedFansVoteAve = (Math.round(fansVoteAve * 2) / 2).toFixed(1) // round nearest .5
        // console.log('roundedFansVoteAve', fansVoteAve, roundedFansVoteAve)

        roundedFansVoteAve = roundedFansVoteAve.replace('.0', '') // remove trailing zero
        
        const playerID = parseInt( key.replace('player','') )
        // console.log('playerID', playerID, roundedFansVoteAve)

        const matchedPlayer = thisState.state.data.filter(player => parseInt(player[0]) === playerID);
        // console.log('matchedPlayer', matchedPlayer[0])
        if ( matchedPlayer[0] ) {
          // matchedPlayer[0].fans = roundedFansVoteAve
          // [3] represents object key for fans votes from the sheet position
          matchedPlayer[0][8] = roundedFansVoteAve
        }
        
    })

    // console.log('totalPlayersVotes', totalPlayersVotes)
    this.setState({
      voteData: items
    })

  }

  submitvote (e,id,voteBracket) {
    e.persist();
    e.target.classList.add(`nnd-voting`)

    const voteKey = 'player' + id + '_' + voteBracket
    // console.log('voteKey', voteKey)
    
    this.setState({
      votingDisabled: true
    })

    let voteData = this.state.voteData

    // submit the vote

    // SEND VOTE
    const documentId = voteData.filter( (el) => voteKey === el.categoryA )[0].docid
    // console.log('documentId', documentId)
    
    axios.post(`${apiUrl}/vote/send`, {
      projectName: apiCollection,
      collectionId: 'vote',
      documentId: documentId
    })
      .then((res) => {
        // console.log('res.data', res.data)
        // e.persist();
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)

        }.bind(this),1000)


      })
      .catch((err) => {
        // console.error(err)
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)
        }.bind(this),1000)
        
      })
    
    // end submit vote

  }

  /*
  setClassName (e, tabName) {
    if (tabName !== this.state.view) {
      // console.log('tabname', tabName)
      // console.log('e', e)
      
      // let header = document.getElementById(`nnd-header`)
      let container = document.getElementById(`nnd-container`)
      // console.log('container', container)
      document.getElementsByClassName(`nnd-header-active-${this.state.view}`)[0].classList.remove(`nnd-header-active-${this.state.view}`)
      document.getElementsByClassName(`nnd-active-${this.state.view}`)[0].classList.remove(`nnd-active-${this.state.view}`)
      e.target.classList.add(`nnd-active-${tabName}`)
      container.classList.add(`nnd-header-active-${tabName}`)
      const grid = document.querySelector('.nnd-cont-main')
      grid.classList.toggle('nnd-hide')
      setTimeout(() => {
        this.state.view = tabName
        grid.setAttribute('name', `nnd-${tabName}`)
        let ratingReaders = grid.querySelectorAll('.nnd-col-rating')
        
        setTimeout(() => {
          grid.classList.toggle('nnd-hide')
          Tracking.trackPageImpression(tabName, project.name)
        }, 200)
      }, 200)
    }
  }
  */

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break

      case 'www.codesportssit.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesports.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesportsuat.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        siteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }

  goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }

  checkBreach () {

    // const whatSite = this.siteCode(window.location.hostname)
    // console.log('site', whatSite)

    const isDeskMobAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isMobileApp = ( isDeskMobAttribute === 'mobile' || isDeskMobAttribute === 'desktop' ) ? false : true
    // console.log('isMobileApp', isMobileApp)

    // console.log('isMobileApp', isMobileApp);
    // console.log('window.utag_data', window.utag_data);
        
    if (isMobileApp) {
      this.state.breach = false
      this.state.isMobApp = true
      this.loadData()

    } else if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'
            + '&v21=dynamic-hot-control-score&V21spcbehaviour=append'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    else {
      setTimeout(this.checkBreach, 250);
    }
    
  }
  

  dataSlash () {
    let slashedData = []

    this.state.data.forEach(function(p) {
      if (p[0] < 4 ) {
        slashedData.push(p)
      }
    })

    // let slashedData = this.state.data.slice(0, 20)

    this.setState({
      data: slashedData
    })
  }

  goSubscribe () {
    window.location.assign(this.state.SubscriptionUrl);
  }

  render() {
    const teamlist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item[0]} className={`nnd-row nnd-player-${item[0]} nnd-player`}>

            <div className="nnd-col-img">
              <img src={require(`../assets/images/${item[2]}.svg`)} />
            </div>
            <div className="nnd-col-text">
              <h3>{ item[1] }</h3>
              {item[3] ? <p><span>Position:</span> { item[3] }</p> : '' }
              {item[4] ? <p>{ item[4] }</p> : '' }
            </div>
           
            <div className="nnd-col-rating">
              <span className='nnd-ratings-expert'>
                <span className='nnd-ratings-heading-expert'>Expert Rating</span>
                <span className='nnd-ratings-headingsub-expert'>{ item[7] }</span>
                <span className="nnd-ratings-expert-score">{ item[5] }</span>
              </span>
              <span className='nnd-ratings-fan'>
                <span className='nnd-ratings-heading-fans'>Avg Fan Rating</span>
                <span className="nnd-ratings-fans-score">{ item[8] }</span>
              </span>
            </div>

            <div className="nnd-slider" data-slider-id={ item[0] }>
              <span className="nnd-rtp">Rate { item[1] }</span>
              <Slider marks={this.state.marks} min={this.state.sliderMin} max={this.state.sliderMax} step={0.5} defaultValue={this.state['slider' + item[0]]} onChange={value=>this.setState({['slider' + item[0]]: value})} />
              <button className="button nnd-submit" disabled={this.state.votingDisabled} onClick={(e) => { this.submitvote(e, item[0], this.state['slider' + item[0]]); e.preventDefault() }} >vote</button>
              <span className="nnd-sliderValue" >{this.state['slider' + item[0]]}</span>
            </div>
          </div>
        )
      }
    }) : ''

    const isBreached = this.state.breach
    const isMobApp = this.state.isMobApp

    return (
      <div id="nnd-container" className={`nnd-header-active-Afl ${isMobApp ? "nnd-mobileApp" : ""} `}>
        <h3 className="nnd-title"><span>AFC Asian Cup Qatar<br />Quarter Final</span>Australia vs South Korea</h3>
        <div name="nnd-afl" className="nnd-cont-main nnd-start-afl">
          {teamlist}
        </div>

        {isBreached === true
          ? 
          <div id="nnd-breach-overlay" className="nnd-breach-overlay">
              {this.state.siteDomain !== 'codesports'
                ?
                <div className="nnd-breach-message-metro">
                  <p className="nnd-bm1"><span>There's more to this story.</span></p>
                  <p className="nnd-bm1"><span>Subscribe to unlock all the players</span></p>
                  <p className="nnd-bm2">$1 a week for the first 12 weeks.<br />(min cost $4)</p>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Subscribe</a>
                  <p className="nnd-bm3"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> | T&Cs apply</p>
                </div>
                :
                <div className="nnd-breach-message-cs">
                  <p className="nnd-bm1">Read the full story.</p>
                  <p className="nnd-bm2">$1 for the first 2 months*</p>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Try Now</a>
                  <p className="nnd-bm4">Already a subscriber? <a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Sign in</a> |  <a href="https://www.codesports.com.au/more-information/terms-and-conditions">*T&Cs apply</a></p>
                </div>
                
              }
          </div>
          : ''
        }

      </div>
      
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js